// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "ComponentAvatar" + "." + "6ed15814" + ".css";
};